import * as React from 'react';
import SearchCaseContactItem from './SearchCaseContactItem';
import { get } from '../../../../Services/NetteApiClient';
import styles from './SearchCaseContact.module.scss';
import ScrollContainer from '../../../BaseModule/Components/ScrollContainer/ScrollContainer';
import FlatList from '../../../BaseModule/Components/FlatList/FlatList';
import SearchCaseContactFilter, {
	SearchCaseContactFilterValues,
} from './SearchCaseContactFilter';
import useFlatData from '../../../BaseModule/Hooks/useFlatData';
import useCaseContacts from '../../Hooks/useCaseContacts';
import SearchCaseContactNoResults from './SearchCaseContactNoResults';
import { useEffect, useState } from 'react';

interface Props {
	linkSelect: any;
	patientId: string;
}

const WRAPPER_ID = 'caseContactWrapper';

const SearchCaseContact: React.FC<Props> = ({ linkSelect, patientId }) => {
	const [isNoResultsDisplayed, setIsNoResultsDisplayed] = useState(false);
	const { getFlatWorkplaces, getNextPage, data, isLoading, page, setPage } =
		useCaseContacts();
	const { flatData, hasMoreData, loadData, setFilter, filter } = useFlatData(
		getFlatWorkplaces,
		{
			data: data?.filterCaseContacts?.data,
			totalPages: data?.filterCaseContacts?.meta?.totalPages,
			page: data?.filterCaseContacts?.meta?.page,
		},
		page,
		setPage,
	);

	useEffect(() => {
		const filterData = filter as SearchCaseContactFilterValues;
		setIsNoResultsDisplayed(
			(filterData.fulltext?.length || 0) > 0 && (flatData?.length || 0) < 1,
		);
	}, [filter, flatData]);

	const handleSelect = async (
		workplaceId?: string,
		workplaceMemberId?: string,
	) => {
		let ajaxLink = linkSelect;

		if (workplaceId) {
			ajaxLink = ajaxLink.replace('=workplaceIdPlaceholder', '=' + workplaceId);
		}
		if (workplaceMemberId) {
			ajaxLink = ajaxLink.replace(
				'=workplaceMemberIdPlaceholder',
				'=' + workplaceMemberId,
			);
		}

		await get(ajaxLink);
	};

	return (
		<div className={styles.wrapper}>
			<SearchCaseContactFilter onFilter={setFilter} />
			{isNoResultsDisplayed && <SearchCaseContactNoResults />}
			<ScrollContainer wrapperId={WRAPPER_ID} className={styles.scrollWrapper}>
				<FlatList
					onRefresh={loadData}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					className={styles.flatWrapper}
					hasMoreData={hasMoreData}
					scrollableTargetId={WRAPPER_ID}
					renderItem={item => (
						<SearchCaseContactItem
							onClick={handleSelect}
							item={item}
							patientId={patientId}
						/>
					)}
				/>
			</ScrollContainer>
		</div>
	);
};

export default SearchCaseContact;
